import { signOut, fetchAuthSession } from 'aws-amplify/auth';
import { toast } from 'react-toastify';
import { FLAG_STORAGE_KEYS } from '@/shared/lib/toolFormFlags';
import { SESSION_EXPIRED_TOAST } from '@/shared/config/urls';

let navigate, store;
export const setNavigate = (nav, str) => {
    navigate = nav;
    store = str;
};

export const handleLogout = async () => {
    try {
      await signOut();
      localStorage.removeItem('user_id');
      navigate('/');
      store.dispatch({ type: 'LOGOUT' });
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.removeItem('user_id');
      for (let key in localStorage) {
        if (key.startsWith('Cognito')) {
          localStorage.removeItem(key);
        }
      }
    }
  };

export const fetchAuthSessionWithLogout = async () => {
  try {
    const { accessToken } = (await fetchAuthSession()).tokens ?? {};
    if (!accessToken) {
      const sessionExpired = localStorage.getItem('session_expired');
      if (sessionExpired && sessionExpired !== 'true') {
        toast.error(SESSION_EXPIRED_TOAST);
        localStorage.setItem('session_expired', 'true');
        await handleLogout();
      }
      return;
    }
    return accessToken;
  } catch (error) {
    console.error('Error fetching auth session:', error);
    await handleLogout();
  }
};

export const clearCache = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
  
  window.indexedDB.databases().then(databases => {
    databases.forEach(database => {
      window.indexedDB.deleteDatabase(database.name);
    });
  }).catch(error => console.error("IndexedDB clear failed:", error));
  
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
  
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  
  const keysToPreserve = ['doctor', 'location', 'audio_language', 'report_language', ...FLAG_STORAGE_KEYS];
  const preservedData = {};
  
  Object.keys(localStorage).forEach(key => {
    if (keysToPreserve.includes(key) || key.endsWith('filters')) {
      preservedData[key] = localStorage.getItem(key);
    }
  });
  
  localStorage.clear();
  sessionStorage.clear();
  
  Object.keys(preservedData).forEach(key => {
    localStorage.setItem(key, preservedData[key]);
  });
  
  if (store && typeof store.dispatch === 'function') {
    store.dispatch({ type: 'LOGOUT' });
  }

  if (navigate && typeof navigate === 'function') {
    navigate('/');
  }
}
